import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { Checkbox as CheckboxCore, Classes } from '@mc/react-core';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { useTheme } from '../useTheme';
import classNames from 'classnames';
import { VFFieldProps } from '../types';

// type BaseProps<P> = Omit<Omit<ComponentProps<typeof BaseField>, keyof WrappedFieldProps>, 'field'> &
//     Partial<Omit<BaseFieldProps<P>, 'component'>> & {name: string};
// export const String = React.memo((props: BaseProps<React.ComponentProps<React.ComponentClass<HTMLInputElement>>>) => (
//     <Field {...props} component={BaseField} field={StringInput} />
// ));
//
//

export type CheckboxProps = VFFieldProps<
  React.ComponentProps<typeof CheckboxCore>
>;
export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      label,
      required,
      disabled,
      ...other
    },
    ref
  ) => {
    const { ns } = useTheme();
    return (
      <FormItem
        name={name}
        label={label}
        required={required}
        disabled={disabled}
      >
        <Field name={name} type="checkbox">
          {({ input: { checked, onChange } }: FieldRenderProps<boolean>) => {
            return (
              <CheckboxCore
                {...other}
                disabled={disabled}
                className={classNames(`${ns}-${Classes.CHECKBOX}`, className)}
                onChange={onChange}
                checked={checked}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
